import React, { ReactNode } from "react";
import { useStore } from "src/stores/Store";
import colors from "src/utils/colors";
import tw from "src/utils/tw";

interface Props {
  age?: number | string;
  isSelected: boolean;
  onClick?: React.MouseEventHandler<any>;
  className?: string;
  theme?: any;
  children?: ReactNode;
  disabled?: boolean;
}

export function AgeButton(props: Props) {
  const store = useStore();
  let bgColor = "#fff";

  if (props.isSelected) {
    if (store.isAdminArea) {
      bgColor = colors.action;
    } else {
      bgColor = store.theme.orgColor;
    }
  }

  return (
    <button
      className={tw(
        "block",
        "flex-1",
        "p-0",
        "border",
        "border-borderGray",
        "h-11",
        "transition",
        "-m-px",
        "cursor-pointer",
        props.isSelected && "text-white",
        props.disabled && "hover:cursor-default"
      )}
      css={{
        backgroundColor: bgColor,
      }}
      disabled={props.disabled}
      type="button"
      onClick={props.onClick}
    >
      <span className={tw(props.disabled && "opacity-20")}>
        {props.children}
      </span>
    </button>
  );
}
